import { render, staticRenderFns } from "./RingSizeInstructions.vue?vue&type=template&id=561b3e34&scoped=true"
import script from "./RingSizeInstructions.vue?vue&type=script&lang=ts"
export * from "./RingSizeInstructions.vue?vue&type=script&lang=ts"
import style0 from "./RingSizeInstructions.vue?vue&type=style&index=0&id=561b3e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b3e34",
  null
  
)

export default component.exports